import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { verificationApi } from "../http/Api";

export const getVerification = createAsyncThunk(
  "Verification/getVerification",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await verificationApi.getVerification(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(verificationSlice.actions.setVerification(response));
    }
  }
);

export const getVerificationAdvanced = createAsyncThunk(
  "Verification/getVerificationAdvanced",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await verificationApi.getVerificationAdvanced(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(verificationSlice.actions.setVerificationAdvanced(response));
    }
  }
);

export const getVerificationRules = createAsyncThunk(
  "Verification/getVerificationRules",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await verificationApi.getVerificationRules(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(verificationSlice.actions.setVerificationRules(response));
    }
  }
);

export const getVerificationMessage = createAsyncThunk(
  "Verification/getVerificationMessage",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await verificationApi.getVerificationMessage(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(verificationSlice.actions.setVerificationMessage(response));
    }
  }
);

export const getVerificationLogs = createAsyncThunk(
  "Verification/getVerificationLogs",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await verificationApi.getLogs(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(verificationSlice.actions.setVerificationLogs(response));
    }
  }
);

const initialState = {
  verificationGlobalState: null,
  verificationAdvancedGlobalState: null,
  verificationRulesGlobalState: null,
  verificationMessageGlobalState: null,
  verificationLogsState: null,
};

const verificationSlice = createSlice({
  name: "verification",
  initialState,
  reducers: {
    setVerification: (state, action) => {
      state.verificationGlobalState = action.payload;
    },
    setVerificationAdvanced: (state, action) => {
      state.verificationAdvancedGlobalState = action.payload;
    },
    setVerificationRules: (state, action) => {
      state.verificationRulesGlobalState = action.payload;
    },
    setVerificationMessage: (state, action) => {
      state.verificationMessageGlobalState = action.payload;
    },
    setVerificationLogs: (state, action) => {
      state.verificationLogsState = action.payload;
    },
  },
});

export const verification = verificationSlice.reducer;
